import React from 'react'
import { PageTitle, Paragraph, ParaTitle, Pagination, ParaImageDialog } from "../common";
import './Updates.css';

const Updates_3_40_0 = () => {
  return (
    <div>
      <PageTitle title='3.40.0' />

      <ParaTitle paraTitle='Draft Auto Save & New Dashboard Design' />
      <Paragraph paragraph='2025-04-02' />

      <ParaTitle paraTitle='Added:' />
      <ul>
        <li>
            Auto save drafts
          <p>Automatically save user's event entry to draft to prevent lost of partially entered events.</p>
        </li>
      </ul>

      <ParaTitle paraTitle='Changed:' />
      <ul>
        <li>Update Dashboard Layout
          <p>Update the front page and dashboards to better accommodate the distinction between event statuses.</p>
          <ParaImageDialog src='/tutorial_image/updates-3-40-0.png' />
        </li>
        {/* <li>Admin user management page optimization
          <p>Optimized page performance by reducing excessive data retrieval. Implemented pagination and limited data fetching to only what is necessary for displaying the table.</p>
        </li>
        <li>Updated tutorial link in login page
        </li>
        <li>Enhanced Google Analytics
        </li> */}
      </ul>

      <Pagination
                pagination={{
                    prev: { name: 'Updates: 3.41.0', link: '/updates/3.41.0' },
                    next: { name: 'Events Summary', link: '/general/events-summary' }
                }}
            />
    </div>

  )
}

export default Updates_3_40_0;